<template>
  <div class="settings-home p-3">
    <div class="settings-home-header">
      <h2>Settings</h2>
      <p>Manage your account, workspace, and integrations</p>
    </div>

    <div
      v-for="group in navGroups"
      :key="group.label"
      class="settings-home-section"
    >
      <h3 class="settings-home-section-title">{{ group.label }}</h3>
      <div class="row g-3">
        <div
          v-for="item in group.items"
          :key="item.slug"
          class="col-12 col-sm-6 col-md-4 col-lg-3"
        >
          <router-link
            :to="'/settings/' + item.slug"
            class="settings-home-card"
          >
            <div class="settings-home-card-icon">
              <BaseIcon :name="item.icon" :type="item.iconType || 'global'" />
            </div>
            <div class="settings-home-card-body">
              <span class="settings-home-card-title">{{ item.label }}</span>
            </div>
            <BaseIcon
              name="right-arrow"
              type="global"
              class="settings-home-card-arrow"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "../icons/BaseIcon";

const navGroups = [
  {
    label: "Account",
    items: [
      {
        slug: "account",
        label: "My Account",
        icon: "user",
        iconType: "settings",
      },
      {
        slug: "billing",
        label: "Billing & Plans",
        icon: "billing",
        iconType: "settings",
      },
    ],
  },
  {
    label: "Workspace",
    items: [
      { slug: "general", label: "General", icon: "settings" },
      {
        slug: "line-options",
        label: "Line Options",
        icon: "tools",
        iconType: "settings",
      },
      { slug: "table-views", label: "Table Views", icon: "menu" },
      { slug: "collection", label: "Collection Points", icon: "box" },
      { slug: "problems", label: "Warehouse Problems", icon: "warning" },
      { slug: "crm", label: "CRM", icon: "customers" },
      { slug: "products", label: "Products", icon: "box2" },
      { slug: "assets", label: "Assets", icon: "assets" },
      { slug: "price-comparison", label: "Price Comparison", icon: "chart-3" },
      { slug: "sales-settings", label: "Sales", icon: "cart" },
      { slug: "income-statement", label: "Income Statement", icon: "document" },
    ],
  },
  {
    label: "AI",
    items: [
      { slug: "ai-workflows", label: "AI Workflows", icon: "diagram" },
    ],
  },
  {
    label: "Organization",
    items: [
      {
        slug: "companies",
        label: "Companies",
        icon: "briefcase",
        iconType: "settings",
      },
      { slug: "warehouses", label: "Warehouses", icon: "buildings" },
      {
        slug: "users",
        label: "Team Members",
        icon: "group",
        iconType: "settings",
      },
    ],
  },
  {
    label: "Sales Channels",
    items: [
      { slug: "events", label: "Events", icon: "calendar" },
      {
        slug: "sale-channels",
        label: "Sale Channels",
        icon: "shopping",
        iconType: "settings",
      },
      { slug: "domains", label: "Domains", icon: "web" },
      { slug: "countries", label: "Countries", icon: "flag" },
      { slug: "couriers", label: "Couriers", icon: "truck-time" },
      { slug: "returns", label: "Return & Change", icon: "change" },
    ],
  },
  {
    label: "Integrations",
    items: [
      {
        slug: "integrations",
        label: "Integrations",
        icon: "puzzle",
        iconType: "settings",
      },
    ],
  },
];

export default {
  name: "Start",
  components: { BaseIcon },
  data() {
    return { navGroups };
  },
};
</script>
